import { Checkbox, Thead, Tr, Th } from '@chakra-ui/react';
import { SortableHeader } from '@duke-hq/ui/components/SortableHeader/SortableHeader';
import { SortOrder } from '@duke-hq/lib/pagination';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';

interface BillableItemsTableHeaderProps {
  canManageXeroInvoices?: boolean;
  isAllSelected: boolean;
  isIndeterminate: boolean;
  toggleSelectAll: () => void;
  hasRows: boolean;
  orderBy?: string;
  sort?: SortOrder;
  onSort: (columnName: string) => void;
}

export function BillableItemsTableHeader({
  canManageXeroInvoices,
  isAllSelected,
  isIndeterminate,
  toggleSelectAll,
  hasRows,
  orderBy,
  sort,
  onSort,
}: BillableItemsTableHeaderProps) {
  return (
    <Thead position="sticky" top={0} zIndex={1} bg="bg.surface">
      <Tr>
        {canManageXeroInvoices === true ? (
          <Th width="48px">
            <Checkbox
              isChecked={isAllSelected === true}
              isIndeterminate={isIndeterminate === true}
              onChange={toggleSelectAll}
              aria-label={t`Select all`}
              isDisabled={!hasRows}
            />
          </Th>
        ) : null}
        <Th width="160px">
          <SortableHeader
            label={t`Provider`}
            columnName="providerDrn"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="140px">
          <SortableHeader
            label={t`Invoice Date`}
            columnName="invoiceDate"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="140px">
          <SortableHeader
            label={t`Due Date`}
            columnName="dueDate"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="140px">
          <SortableHeader
            label={t`Status`}
            columnName="status"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="260px">
          <Trans>Description</Trans>
        </Th>
        <Th width="140px">
          <SortableHeader
            label={t`Unit Amount`}
            columnName="unitAmount"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="100px">
          <Trans>Currency</Trans>
        </Th>
        <Th width="160px">
          <SortableHeader
            label={t`Xero`}
            columnName="xeroInvoiceNumber"
            currentOrderBy={orderBy}
            currentSortOrder={sort}
            onSortChange={onSort}
          />
        </Th>
        <Th width="80px">
          <Trans>Details</Trans>
        </Th>
      </Tr>
    </Thead>
  );
}
